import * as Yup from 'yup';
import { useRef, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../common/SnackbarAlert';
import React from 'react';
function CreateEdit({
  closeCreateEditForm,
  vehichleVariantEditDatas,
  editStatus,
  modelId='',
  setNewValue=null
}) {
  // const regExp = /^(\d+(?:[\.\,]\d{2})?)$/;

  const VehichleVariantSchema = Yup.object().shape({
    name: Yup.string()
      .required('Vehicle Variant Name is required')
      // .min(3, 'Vehicle Variant Name must be at least 3 character')
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'Vehicle Variant only accepts special characters like &,[,],-,/,(,)'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Vehicle Model Variant must include at least one letter of the alphabet'
      // )
      .test(
        'no-leading-space',
        'Cannot start with a space',
        (value) => !value || value.trimStart() === value
      ),
    code: Yup.string()
      .required('Vehicle Variant Code is required'),
    rate: Yup.string()
      .required('Vehicle Variant rate is required')  

  });

  const cancelClickedFlag = useRef(false);
  const [loader, setLoader] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const formik = useFormik({
    initialValues: {
      id: '',
      name: '',
      code: '',
      status: true,
      vehicleModelId: 0,
      rate: 0,
    },
    validationSchema: VehichleVariantSchema,
    onSubmit: (values) => {
      values.name = String(values.name);
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      const url = editStatus ? 'vehichle/vehicleVariant/'+values.id : 'vehichle/createVehicleVariant'
      request({
        url: url,
        method: method,
        data: values
      })
        .then((vehichleType) => {
          if (vehichleType.status) {
            if (setNewValue) {
              setNewValue(values?.name);
            }
            closeCreateEditForm(true);
            setLoader(false);
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: vehichleType['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const routeArray = window.location.pathname.split('/');
  formik.initialValues.vehicleModelId =modelId?parseInt(modelId): parseInt(routeArray[5]);
  if (editStatus) {
    formik.values.id = vehichleVariantEditDatas.id;
    formik.initialValues.name = vehichleVariantEditDatas.name;

    formik.initialValues.code = vehichleVariantEditDatas.code;
    formik.initialValues.rate = vehichleVariantEditDatas.rate;

  }
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const handleCancelMouseDown = () => {
    cancelClickedFlag.current = true;
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12} className='ListContainer'>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Vehicle Variant" />
              ) : (
                <CardHeader title="Create Vehicle Variant" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Name{' '}
                            <Typography
                              component="span"
                              sx={{ color: 'red' }}
                            >
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="name"
                        value={capitalizeFirst(formik.values.name)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          if (!cancelClickedFlag.current) {
                            formik.handleBlur(e);
                          }
                        }}
                        error={
                          formik.touched.name &&
                          Boolean(formik.errors.name)
                        }
                        helperText={
                          formik.touched.name &&
                          formik.errors.name
                        }
                      />
                    </Grid>


                    <Grid item xs={6}>
                      <TextField
                         label={
                          <React.Fragment>
                            Code{' '}
                            <Typography
                              component="span"
                              sx={{ color: 'red' }}
                            >
                              *
                            </Typography>
                          </React.Fragment>
                        }

                        sx={{ width: '100%' }}
                        size="small"
                        type="string"
                        name="code"
                        value={formik.values.code}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          if (!cancelClickedFlag.current) {
                            formik.handleBlur(e);
                          }
                        }}
                        error={
                          formik.touched.code &&
                          Boolean(formik.errors.code)
                        }
                        helperText={
                          formik.touched.code &&
                          formik.errors.code
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label={'Rate'}

                        sx={{ width: '100%' }}
                        size="small"
                        type="number"
                        name="rate"
                        value={formik.values.rate}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          if (!cancelClickedFlag.current) {
                            formik.handleBlur(e);
                          }
                        }}
                        error={
                          formik.touched.rate &&
                          Boolean(formik.errors.rate)
                        }
                        helperText={
                          formik.touched.rate &&
                          formik.errors.rate
                        }
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                        onMouseDown={handleCancelMouseDown}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default CreateEdit;
